import { FC } from "react";
import { ModalDialog } from "@rothoblaas/design-system";
import useI18n from "../../hooks/useTranslations";
import { ProjectLight } from "../../http/types/projects";
import { ProjectForm } from "./ProjectForm";

interface ProjectModalProps {
  onClose: () => void;
  onSuccess?: (project?: ProjectLight) => void;
}

const ProjectModal: FC<ProjectModalProps> = ({ onClose, onSuccess }) => {
  const i18n = useI18n();

  return (
    <>
      <ModalDialog onClose={onClose} title={i18n.translation.projects.createNew}>
        <ProjectForm disableNavigationOnSuccess onSuccess={onSuccess} onClose={onClose} />
      </ModalDialog>
    </>
  );
};

export default ProjectModal;
